// import * as PIXI from 'pixi.js'
// import moment from 'moment'
import { distToLine, distToRect } from '../utils'
import Tool from './tool.class'

export default class DrawShieldLine extends Tool {
  update(event, config, container, pixiObj, options, vm) {
    super.update(...arguments)
    this.config.bias = config.bias || 20
  }
  mouseDown(event) {
    const labelList = this.config.data
    if (labelList.length === 0) {
      return
    }
    const { offsetX, offsetY } = event
    const distences = labelList.map(label => {
      let distFunc = null
      switch (label.shape) {
        case 'line':
          distFunc = distToLine
          break
        case 'rect':
          distFunc = distToRect
          break
      }
      return distFunc(
        [offsetX, offsetY],
        [
          label.area[0] * this.options.width,
          label.area[1] * this.options.height,
        ],
        [
          label.area[2] * this.options.width,
          label.area[3] * this.options.height,
        ],
      )
    })
    const minDist = Math.min.apply(Math, distences)
    let labelIdx = null
    if (minDist <= this.config.bias) {
      labelIdx = distences.indexOf(minDist)
    }
    this.$msg({
      type: 'INSPECT_LABEL',
      index: labelList[labelIdx].idx,
      options: this.options,
    })
  }
  mouseUp(event) {}
  mouseWheel(event) {}
  mouseMove(event) {}
  mouseLeave(event) {}
}
